import React, { Component } from 'react'

export default class Select extends Component {
    state = {
        disabled: false
    }

    getOptions = (opt) => {
        var result = []

        opt.forEach((element, index) => {
            result.push(<option key={index}>{element}</option>)
        });

        return result;
    }

    static getDerivedStateFromProps(props, state) {
        return {
            disabled: props.disabled
        };
    }

    render() {
        return (
            <div className={this.props.fill === undefined || this.props.fill === false? "div-select": "div-select-fill"}
                style={{
                    display: "flex",
                    float: "right",
                    alignSelf: "center"
                }}
            >
                <select
                    disabled={this.state.disabled || this.props.options.length <= 1}
                    style={{
                        width: "100%",
                        textAlign: "center"
                    }}
                    onChange={(e)=>{
                        if(this.props.handleChange !== undefined)  
                            this.props.handleChange(e.target.value)
                    }}
                    value={this.props.value}
                >
                    {this.getOptions(this.props.options)}
                </select>
            </div>
        )
    }
}
